// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_categories/kv.
 *
 * Returns active service categories as key-value pairs for dropdowns.
 */
import type { ServiceCategories_KvRow } from './ServiceCategories_KvRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServiceCategories_KvResponseDados = ServiceCategories_KvRow[];

export type ServiceCategories_KvResponse = ApiResponse<ServiceCategories_KvResponseDados>;

registerResponseContract('ServiceCategories_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
